module.exports = __webpack_public_path__ + "static/media/ScreenIcon.0ca9c58c.svg";